import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/root/repo/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager" */ "/root/repo/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/contact/basic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/primitives/button.tsx");
